import React, { useCallback, useContext, useState } from "react";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import cs from "classnames";

// import Avatar from "../../atoms/Avatar";
import Button, { COLORS } from "../../atoms/Button";
import Icon from "../../atoms/Icon";
import Loader from "../../atoms/Loader";
import Tooltip, {
  COLORS as TOOLTIP_COLORS,
  POSITIONS as TOOLTIP_POSITIONS,
} from "../Tooltip";
import Popover, {
  POSITIONS as POPOVER_POSITIONS,
  usePopover,
} from "../../organisms/Popover";
import Modal from "../../organisms/Modal";
import GoogleAuth from "../../organisms/GoogleAuth";
import { APPLICATION_ROUTES, COOKIES } from "../../../constants";
import { StoreContext } from "../../../contexts";
import { ACTIONS } from "../../../store";
import { isMobileDevice, scrollToTop } from "../../../utilities/helpers";
import classes from "./ProfileMenuHeb.module.scss";
import LetterPicture from "../../atoms/LetterPIcture";
// import Partnership from "../Partnership";
import Cookies from "../../../utilities/cookies";
import { BrowserView, MobileView, isMobile } from "react-device-detect";
import { WRITING_COMPETITON_DATA_KEY } from "../../pages/WritingCompetition/WritingCompetition";
import PasswordInput from "../../atoms/PasswordInput";
import deleteIcon from "../../../assets/images/delete.png";
// import { scroller } from "react-scroll";

const ProfileMenuHeb = observer(({ id, modalMenu }) => {
  const { authorization, common } = useContext(StoreContext);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [showPasswordVerify, setShowPasswordVerify] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const onSignOut = () => {
    Cookies.delete({ name: COOKIES.AUTO_SIGNIN });
    Cookies.delete({ name: COOKIES.CART_ID });
    common.set(WRITING_COMPETITON_DATA_KEY, null);

    authorization.signOut();
  };

  const dropdown = usePopover({
    position: isMobile
      ? POPOVER_POSITIONS.RIGHT_TOP_MOBILE
      : modalMenu
        ? POPOVER_POSITIONS.MODAL_MENU_TOP_LEFT
        : POPOVER_POSITIONS.RIGHT_BOTTOM_OUT,
    selector: `#${id}`,
  });

  const history = useHistory();
  // const onNavigateToProfile = useCallback(() => {
  //   history.push(APPLICATION_ROUTES.PROFILE);
  //   scrollToTop();
  // }, []);
  // const onNavigateToBirthday = useCallback(() => {
  //   history.push(APPLICATION_ROUTES.MY_MAOR_MAIN + "?birthday");
  //   // scrollToTop();
  //   scroller.scrollTo("packages", { duration: 500, smooth: true, offset: -24 });
  // });

  const onNavigateToSignIn = useCallback(() => {
    history.push(APPLICATION_ROUTES.SIGN_IN);
    scrollToTop();
  }, []);

  const { t } = useTranslation();
  const MESSAGE = "";

  const handleDeleteAccountClick = () => {
    dropdown.close();
    setShowDeleteConfirm(true);
  };

  const handleContinueToDelete = () => {
    setShowDeleteConfirm(false);
    setShowPasswordVerify(true);
  };

  const handleGoogleAuthSuccess = (userData) => {
    if (
      userData.email.toLowerCase() === authorization.user.email.toLowerCase()
    ) {
      authorization.deleteAccount({
        onSuccess: () => {
          setShowPasswordVerify(false);
          history.push(APPLICATION_ROUTES.SIGN_IN);
        },
      });
    } else {
      setPasswordError(
        t("authorization.errors.google_email_mismatch") || "Email mismatch"
      );
    }
  };

  const handlePasswordVerify = () => {
    if (!password) {
      setPasswordError(t("authorization.errors.password_required") || "שדה חובה");
      return;
    }

    authorization.autheticatePassword(
      authorization.user.email,
      password,
      () => {
        // onSuccess
        authorization.deleteAccount({
          onSuccess: () => {
            setShowPasswordVerify(false);
            history.push(APPLICATION_ROUTES.SIGN_IN);
          }
        });
      }
    );
  };

  if (
    authorization.isLoadingSignIn ||
    authorization[`isLoading${ACTIONS.AUTHORIZATION.RESIGN_IN}`]
  ) {
    return (
      <div className={classes.container}>
        <Loader />
      </div>
    );
  }

  let memberIcon = "";
  if (
    authorization.isAuthenticated &&
    authorization.isUserMember &&
    authorization.membership
  ) {
    memberIcon = classes[authorization.membership.memberClass];
  }

  return (
    <div className={classes.container}>
      {authorization.isAuthenticated ? (
        <>
          <div className={classes.menu} id={id} onClick={dropdown.open}>
            {isMobile ? (
              <MobileView>
                {authorization.isUserMember && authorization.membership ? (
                  <div
                    className={cs(
                      classes.familyWrapper,
                      classes.paidMember,
                      memberIcon
                    )}
                  >
                    <div className={classes.avatar}>
                      <span>
                        {authorization.lastName.charAt(0).toUpperCase()}
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className={classes.familyWrapper}>
                    <div className={classes.avatar}>
                      <LetterPicture
                        color="#FF8A34"
                        name={authorization.lastName}
                      />
                    </div>
                  </div>
                )}
              </MobileView>
            ) : (
              <BrowserView>
                <div className={classes.familyWrapper}>
                  {/* {authorization.isAuthenticated && (
                    <div className={classes.avatar}>
                      <LetterPicture
                        color="#FF8A34"
                        name={authorization.lastName}
                      />
                    </div>
                  )} */}
                  <div
                    className={cs(
                      classes.familyWelcomeText,
                      classes.marginBottom
                    )}
                  >
                    <p className={classes.textProfileMenu}>
                      {t("components.molecules.profile_menu.texts.2")} <br />
                      {t("layout.family")}
                      <strong>
                        {authorization.lastName.charAt(0).toUpperCase() +
                          authorization.lastName.slice(1)}
                      </strong>{" "}
                    </p>
                    <span className={cs(classes.accountText)}>
                      {t("components.molecules.profile_menu.texts.3")}{" "}
                      <Icon name="arrow-dropdown" size="xs" />{" "}
                    </span>
                  </div>
                  {authorization.isUserMember && authorization.membership ? (
                    <>
                      {authorization?.membership?.memberClass == "partner" ? (
                        <div
                          className={cs(
                            classes.familyWrapper,
                            classes.paidMember,
                            memberIcon
                          )}
                        >
                          <div className={classes.avatar}>
                            <span>
                              {authorization.lastName.charAt(0).toUpperCase()}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className={classes.membershipBadge}>
                          <img
                            src={authorization.membership.Icon}
                            alt={t(authorization.membership.ILLUSTRATION_NAME)}
                          />
                        </div>
                      )}
                    </>
                  ) : null}
                  {/* {!authorization.user.has_purchased_partnership ? (
                    <div className={classes.becomePartner}>
                      <Link
                        to={APPLICATION_ROUTES.PARTNERS_PACKAGES}
                        className="c-orange"
                      >
                        Become <br /> Partner
                      </Link>
                    </div>
                  ) : null} */}
                </div>
              </BrowserView>
            )}

            {MESSAGE && (
              <div className={classes.information}>
                <Tooltip
                  color={TOOLTIP_COLORS.WHITE}
                  message={MESSAGE}
                  position={TOOLTIP_POSITIONS.RIGHT_TOP_OUT}
                  size="m"
                >
                  <Icon name="information" size="s" />
                </Tooltip>
              </div>
            )}
          </div>
          <Popover
            disablePortalSelector={true}
            close={dropdown.close}
            style={dropdown.style}
          >
            <ul className={cs(classes.dropdown, "bxsh-hard")}>
              {/* <li className={classes.subscription}>
                <Partnership dropdown={dropdown} />
              </li> */}

              <li className={classes.item}>
                <button
                  className={classes.button}
                  onClick={handleDeleteAccountClick}
                >
                  <span className="mr-03">
                    <img src={deleteIcon} alt="delete" style={{ width: "20px" }} />
                  </span>
                  <span className="c-red">מחיקת חשבון</span>
                </button>
              </li>

              <li className={classes.item}>
                <button className={classes.button} onClick={onSignOut}>
                  <span className="mr-03 c-red">
                    <Icon name="logout" />
                  </span>
                  <span>{t("components.molecules.profile_menu.labels.3")}</span>
                </button>
              </li>



              <hr className={cs(classes.boundary)} />
              <p className={cs(classes.mailText)}>{authorization.user.email}</p>
            </ul>
          </Popover>

          {/* Delete Account Confirmation Modal */}
          <Modal
            disableOverlay={true}
            opened={showDeleteConfirm}
            onClose={() => setShowDeleteConfirm(false)}
            style={{ "z-index": "201" }}
          >
            <div className="wrapper-s pt-12 pb-12">
              <div className="br-06 pt-10 pb-10 pr-06 pl-06 bgc-white ta-center">
                <div className={classes.iconWrapper}>
                  <img
                    src={deleteIcon}
                    alt="delete"
                    style={{ width: "40px" }}
                  />
                </div>
                <h3 className="heading-l-a c-blue-dark">
                  {t("pages.authorization.delete_account.confirm_title")}
                </h3>
                <p className="pt-03">
                  {t("pages.authorization.delete_account.confirm_body")}
                </p>
                <div className={cs("mt-04", classes.warningBox)}>
                  <span>{t("pages.authorization.delete_account.confirm_warning")}</span>
                </div>
                <div className="d-flex jc-space-around mt-07">
                  <Button
                    color={COLORS.GHOST}
                    onClick={handleContinueToDelete}
                  >
                    {t("pages.authorization.delete_account.continue_to_delete")}
                  </Button>
                  <Button onClick={() => setShowDeleteConfirm(false)}>
                    {t("pages.authorization.delete_account.cancel")}
                  </Button>
                </div>
              </div>
            </div>
          </Modal>

          {/* Password Verification Modal */}
          <Modal
            disableOverlay={true}
            opened={showPasswordVerify}
            onClose={() => setShowPasswordVerify(false)}
            style={{ "z-index": "201" }}
          >
            <div className="wrapper-s pt-12 pb-12">
              <div className="br-06 pt-10 pb-10 pr-06 pl-06 bgc-white ta-center">
                <h3 className="heading-l-a c-blue-dark">
                  {t("pages.authorization.delete_account.verify_title")}
                </h3>
                <p className="pt-03">
                  {t("pages.authorization.delete_account.verify_body")}
                </p>

                <div className={cs("mt-07", classes.passwordVerification)}>
                  <PasswordInput
                    error={
                      passwordError ||
                      (authorization[
                        `error${ACTIONS.AUTHORIZATION.AUTHENTICATE_PASSWORD}`
                      ]
                        ? t("layout.password_confirmation_failed")
                        : "")
                    }
                    id="delete-account-password"
                    label={t("pages.authorization.delete_account.password_label")}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setPasswordError("");
                    }}
                    stretched
                  />
                </div>

                {
                  !isMobileDevice() ?
                    <>
                      <div
                        className={cs(
                          classes.orSeparator,
                          "mt-05",
                          "mb-05",
                          classes.orSeparatorWhite
                        )}
                      >
                        <label>{t("pages.authorization.sign_in.text.2")}</label>
                      </div>

                      <div className="d-flex jc-center">
                        <GoogleAuth
                          reauthenticate={true}
                          onSuccess={handleGoogleAuthSuccess}
                        />
                      </div>
                    </>
                    : ""
                }

                <div className="d-flex jc-space-around mt-07">
                  {authorization[
                    `isLoading${ACTIONS.AUTHORIZATION.AUTHENTICATE_PASSWORD}`
                  ] ||
                    authorization[
                    `isLoading${ACTIONS.AUTHORIZATION.DELETE_ACCOUNT}`
                    ] ? (
                    <Loader />
                  ) : (
                    <>
                      <Button
                        color={COLORS.GHOST}
                        onClick={handlePasswordVerify}
                      >
                        {t("pages.authorization.delete_account.verify_button")}
                      </Button>
                      <Button onClick={() => setShowPasswordVerify(false)}>
                        {t("pages.authorization.delete_account.cancel")}
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </Modal>
        </>
      ) : (
        <>
          {isMobile ? (
            <MobileView>
              <>
                <div className={classes.menu} id={id} onClick={dropdown.open}>
                  <div className={classes.familyWrapper}>
                    <div className={classes.avatar}>
                      <Icon name="user" />
                    </div>
                  </div>
                </div>
                <Popover close={dropdown.close} style={dropdown.style}>
                  <ul className={cs(classes.dropdown, "bxsh-hard")}>
                    <li className={classes.item}>
                      <Link to={APPLICATION_ROUTES.SIGN_IN}>
                        {t("components.molecules.profile_menu.labels.2")}
                      </Link>
                    </li>
                    <li className={classes.item}>
                      <Link to={APPLICATION_ROUTES.SIGN_UP}>
                        {t("components.molecules.profile_menu.labels.1")}
                      </Link>
                    </li>
                  </ul>
                </Popover>
              </>
            </MobileView>
          ) : (
            <BrowserView>
              <div className={classes.authorization}>
                <div className={classes.signUp}>
                  <Link to={APPLICATION_ROUTES.SIGN_UP}>
                    {t("components.molecules.profile_menu.labels.1")}
                  </Link>
                </div>
                <div className={classes.signIn}>
                  <Button size="s" onClick={onNavigateToSignIn}>
                    {t("components.molecules.profile_menu.labels.2")}
                  </Button>
                </div>
              </div>
            </BrowserView>
          )}
        </>
      )}
    </div>
  );
});

ProfileMenuHeb.propTypes = {
  id: PropTypes.string.isRequired,
};

export default ProfileMenuHeb;
